import React from "react";
import List from "@material-ui/core/List";

const CalendarListView = (props: any, listRef: any) => {
    const { style, children } = props;
    return (
        <List
            ref={listRef}
            component={"div"}
            style={{...style}}
        >
            {children}
        </List>
    );
};

export default CalendarListView;